<template lang="pug">
  v-container()
    v-row(justify="center" )
      v-col()
        v-btn(icon href="http://www.twitter.com/cityofrefugeucc" target="_blank" )
          v-icon.mdi.mdi-twitter(x-large) 
        span.headline  Twitter
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
